export const TEMPORARY_LOGIN = 'tempLogin';
export const ALBUMS_BY_EVENT_TOKEN = 'albumsbyeventtoken';
export const CREATE_ALBUM = 'createalbum';
export const UPDATE_ALBUM = 'updatealbum';
export const LICENSE = 'license';
export const GET_LICENSE_VERSION = 'getlicenseversion';
export const DEPLOY2 = 'deploy2';
export const CLOSEALBUM2 = 'closealbum2';
export const REOPENALBUM = 'reopenalbum';
export const ALBUMPROGRESS = 'albumprogress';
export const SMARTBOOK = 'smartbook';
export const RESOLUTION = 'resolution';
export const CHANGETHEME = 'changetheme';
export const UPDATETREE = 'updatetree';
export const TREE_NO_MODEL = 'treenomodel';
export const ALBUMTHEMES = 'albumthemes';
export const DELETE_IMAGE = 'deleteimage';
export const SET_COVER_IMAGE = 'setcover';
export const SET_IMAGE_TEXT = 'settext';
export const SEND_EVENT = 'send_event';

// connect
export const USER_INFO = 'info';
export const VALIDATE_TOKEN = 'refreshtoken';
export const CREATE_SESSION = 'createsession';
// picasa
export const PICASA_GET_ALBUMS = 'get_albums';
export const PICASA_GET_PHOTOS = 'get_photos';
// payment api
export const GETBOOKPRICEBYPAGES = 'getbookpricebypages';
export const GETBOOKPRICE = 'getbookprice';
export const GETFORMATPRICES = 'getformatprices';
export const ADDBASKET = 'add_basket';
